<template>
  <div class="page-section">
    <h1 class="section-title">
      Is your money making money?
    </h1>
    <p v-if="availableFunds.total > 0" class="section-subtitle">
      Your available investment funds are £{{ availableFunds.total }}. Should we put them to work for you?
    </p>
    <p v-else class="section-subtitle">
      Have free money to invest? log in to your eToro wallet and put it to work for you.
    </p>
    <div
      v-if="isDataMissing"
      class="connect-another-subtitle"
    >
      We don't have enough data to display your insights.
      <b @click="handleConnectAccountsClick">connect an active account</b>
      to get the full picture.
    </div>
    <button
      v-else
      class="green-button"
      @click="navigateToEtoro"
    >
      Put your cash to work <span class="arrow-right">→</span>
    </button>

    <div class="divider-line" />
  </div>
</template>

<script setup>
const props = defineProps({
  availableFunds: {
    type: Object,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['navigateToEtoro', 'connectAccountsClick']);

const navigateToEtoro = () => {
  emit('navigateToEtoro');
};

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style scoped>
.page-section {
  color: white;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 20px;
}

.section-title {
  font-size: 48px;
  font-weight: bold;
  font-family: CircularStd;
  line-height: 1;
  margin-top: 30px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.section-subtitle {
  font-size: 19px;
  font-family: CircularStdBook;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.green-button {
  background-color: #205441;
  box-shadow: 0px 4px 21px rgba(149.13, 152.94, 149.88, 0.56);
  border-radius: 12px;
  color: white;
  padding: 17px 0px;
  border: none;
  width: 90%;
  cursor: pointer;
  font-size: 18px;
  font-family: CircularStdBook;
  font-weight: 700;
  margin: 40px auto;
  display: block;
}

.arrow-right {
  margin-left: 10px;
  font-family: CircularStdBook;
}

.divider-line {
  width: 90%;
  margin: 0 auto;
  margin-top: 30px;
  height: 1px;
  background-color: white;
  opacity: 0.5;
}

.connect-another-subtitle {
  font-size: 14px;
  font-family: CircularStdBook;
  margin-bottom: 10px;
  margin-top: 10px;
  background-color: #FFDC73;
  color: #205441;
  text-align: center;
  padding: 20px;
  border-radius: 16px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
</style>
